export default "__VITE_ASSET__9535b942__"